/*
 * Copyright 2026 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/kmp-project-template/blob/main/LICENSE
 */
package kpt.core.data.config

import org.koin.core.qualifier.named

/**
 * GENERATED from `@DataProvider(qualifier = …)`. DO NOT HAND-EDIT.
 *
 * Koin matches a `single<T>` by RAW class, not full KType, so several bindings that erase to
 * the same type (every `SubmitOutbox<*>`) collapse to whichever registered last unless each
 * declares a qualifier. Generating these beside the bindings means a qualifier cannot name a
 * binding that does not exist, and a binding cannot be left unqualified by accident.
 */
object AppOutboxQualifiers {
    /** `SubmitOutbox<BillReminder>` from `provideBillReminderOutbox`. */
    val BillReminder = named("outbox.billReminder")
    /** `SubmitOutbox<Loan>` from `provideLoanOutbox`. */
    val Loan = named("outbox.loan")
    /** `SubmitOutbox<LoanCalcScenario>` from `provideLoanCalcScenarioOutbox`. */
    val LoanCalcScenario = named("outbox.loanCalcScenario")
    /** `SubmitOutbox<PriceAlert>` from `providePriceAlertOutbox`. */
    val PriceAlert = named("outbox.priceAlert")
}
